export default {
  buttons: {
    cancel: "Cancelar",
    dismiss: "Cierre",
    add_waypoint: "Agrega un destino"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "millas"
    }
  },
  search: {
    title: "Buscar",
    placeholder: "Ingresá una ubicación",
    enter_location: "Ingresá una ubicación",
    help: {
      inactive: "Buscar"
    }
  },
  filters: {
    title: "Filtros",
    amenities: {
      title: "Servicios"
    },
    fuels: {
      title: "Combustibles disponibles"
    }
  },
  directions: {
    title: "Planificador de ruta ",
    placeholder: {
      destination: "Ingresá una ubicación",
      waypoint: "Ingresá una ubicación"
    },
    route: {
      title: "Opciones de Ruta",
      avoid_tolls: "Evitar autopistas con peaje",
      avoid_highways: "Evitar autopistas ",
      title_corridor: "Distancia desde la ruta a estaciones de servicio"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# día} other {# días}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# minutos}}\
`,
    button: "Buscar"
  },
  locations: {
    title: "localizaciones",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} De {place}"
  },
  info_window: {
    title: "Detalles del sitio",
    location_id: "Número de Estación",
    services: "Servicios",
    nearby: "cercanía",
    opening_hours: {
      title: "Horario de apertura y de cierre",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Última actualización",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Planificador de ruta "
  },
  fuels: {
    cng: "GNC",
    low_octane_gasoline: "Shell Comun",
    midgrade_gasoline: "Formula Shell Super",
    premium_diesel: "Shell V-Power Nitro+ Diesel",
    premium_gasoline: "Shell V-Power Nitro+ Nafta",
    shell_regular_diesel: "Shell Formula Diesel"
  },
  amenities: {
    air_and_water: "Aire",
    atm: "Cajero automático",
    austrian_highway_sticker: "Sticker de autopista austriaco",
    bank_note_acceptor: "Cajero automático para depósitos",
    bottled_gas: "Cambio de tubo de propano para BBQ",
    cafe: "Cafetería",
    carwash: "Lavadero de autos",
    clubsmart_card: "Club Smart card",
    credit_card_american_express: "Tarjeta de crédito - American Express",
    credit_card_diners_club: "Tarjeta de crédito - Diners Club",
    credit_card_mastercard: "Tarjeta de crédito - Mastercard",
    credit_card_visa: "Tarjeta de crédito - Visa",
    credit_card: "Tarjeta de crédito",
    czech_highway_sticker: "Sticker de autopista checo",
    fleet_card_dkv: "tarjeta de flota - DKV",
    fleet_card_eni: "tarjeta de flota - Eni",
    fleet_card_esso: "tarjeta de flota - ESSO",
    fleet_card_general: "tarjeta de flota",
    fleet_card_uta: "tarjeta de flota - UTA",
    food_offerings: "Oferta de comida",
    full_service: "Servicio completo/Servicio atendido",
    guarded_car_park: "estacionamiento con vigilancia",
    hgv_lane: "acondicionada para camiones",
    high_speed_diesel_pump: "Diesel de alta velocidad",
    hot_food: "Comida caliente",
    hungarian_highway_sticker: "Sticker de autopista húngara",
    ido_ticket: "Ticket Ido",
    maut_terminal: "Terminal Maut",
    parking_lanes: "Carril de estacionamiento",
    partner_loyalty_accepted: "Lealtad de los socios Aceptado",
    pay_at_pump: "Pagar en surtidor",
    restaurant: "Restaurante",
    self_service: "Auto servicio",
    service_bay: "Bahia de servicio",
    shower: "Ducha",
    slovak_highway_sticker: "Sticker de autopista esloveno",
    snack_food: "Comidas rápidas",
    standard_toilet: "Baño",
    supermarket_fuel_discount: "Descuento de combustibles",
    toilet: "Baño",
    truck_parking: "Estacionamiento de camiones",
    truckport: "Solo camiones",
    twenty_four_hour: "24 horas",
    vacuum: "Aspiradora",
    vehicle_identity_system: "Sistema de identidad de vehiculo"
  },
  settings: {
    title: "configuración",
    tooltip: "configuración",
    distance_units: {
      title: "Distancia",
      km: "kilometros",
      miles: "millas"
    },
    language: {
      title: "Idioma"
    }
  }
}
